import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=20b078f1&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=20b078f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b078f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b078f1')) {
      api.createRecord('20b078f1', component.options)
    } else {
      api.reload('20b078f1', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=20b078f1&scoped=true&", function () {
      api.rerender('20b078f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/WhatsappTemplates/Modal.vue"
export default component.exports